import apiClient from '@/services/axios'

export async function del(campaignId) {
  var response = await apiClient.delete('/ActivationPlanCampaigns/' + campaignId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete campaign.')
}